export const yearDataColumn = [
  { time: 1, dataUsage: 13000, label: "13000 GB" },
  { time: 2, dataUsage: 16500, label: "16500 GB" },
  { time: 3, dataUsage: 14250, label: "14250 GB" },
  { time: 4, dataUsage: 19000, label: "19000 GB" },
  { time: 5, dataUsage: 250, label: "250 GB" },
  { time: 6, dataUsage: 18600, label: "18600 GB" },
  { time: 7, dataUsage: 11010, label: "11010 GB" },
  { time: 8, dataUsage: 5789, label: "5789 GB" },
  { time: 9, dataUsage: 13000, label: "13000 GB" },
  { time: 10, dataUsage: 9800, label: "hejhehj" },
  { time: 11, dataUsage: 18700, label: "nfjer" },
  { time: 12, dataUsage: 1350, label: "1350 GB" },
]

export const monthDataColumn = [
  { time: 1, dataUsage: 3000, label: "13000 GB" },
  { time: 2, dataUsage: 26500, label: "16500 GB" },
  { time: 3, dataUsage: 4250, label: "14250 GB" },
  { time: 4, dataUsage: 29000, label: "19000 GB" },
  { time: 5, dataUsage: 2250, label: "250 GB" },
  { time: 6, dataUsage: 10600, label: "18600 GB" },
  { time: 7, dataUsage: 1010, label: "11010 GB" },
  { time: 8, dataUsage: 12789, label: "5789 GB" },
  { time: 9, dataUsage: 14000, label: "13000 GB" },
  { time: 10, dataUsage: 0, label: "hejhehj" },
  { time: 11, dataUsage: 700, label: "nfjer" },
  { time: 12, dataUsage: 21350, label: "1350 GB" },
  { time: 13, dataUsage: 0, label: "1350 GB" },
  { time: 14, dataUsage: 81350, label: "1350 GB" },
  { time: 15, dataUsage: 350, label: "1350 GB" },
  { time: 16, dataUsage: 3000, label: "13000 GB" },
  { time: 17, dataUsage: 26500, label: "16500 GB" },
  { time: 18, dataUsage: 4250, label: "14250 GB" },
  { time: 19, dataUsage: 29000, label: "19000 GB" },
  { time: 20, dataUsage: 2250, label: "250 GB" },
  { time: 21, dataUsage: 10600, label: "18600 GB" },
  { time: 22, dataUsage: 10600, label: "18600 GB" },
  { time: 23, dataUsage: 10600, label: "18600 GB" },
  { time: 24, dataUsage: 10600, label: "18600 GB" },
  { time: 25, dataUsage: 10600, label: "18600 GB" },
  { time: 26, dataUsage: 10600, label: "18600 GB" },
  { time: 27, dataUsage: 1010, label: "11010 GB" },
  { time: 28, dataUsage: 12789, label: "5789 GB" },
  { time: 29, dataUsage: 14000, label: "13000 GB" },
  { time: 30, dataUsage: 3000, label: "13000 GB" },
  { time: 31, dataUsage: 14000, label: "13000 GB" },
]

export const yearLabelsColumn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export const fullYearLabelsColumn = [
  "Jan 2022",
  "Feb 2022",
  "Mar 2022",
  "Apr 2022",
  "May 2022",
  "Jun 2022",
  "Jul 2022",
  "Aug 2022",
  "Sep 2022",
  "Oct 2022",
  "Nov 2022",
  "Dec 2022",
]

export const monthLabelsColumn = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
]

export const dayLabelsColumn = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
]

export const fullMonthLabelsColumn = [
  "2022-09-19",
  "2022-09-20",
  "2022-09-21",
  "2022-09-22",
  "2022-09-23",
  "2022-09-24",
  "2022-09-25",
  "2022-09-26",
  "2022-09-27",
  "2022-09-28",
  "2022-09-29",
  "2022-09-30",
  "2022-10-01",
  "2022-10-02",
  "2022-10-03",
  "2022-10-04",
  "2022-10-05",
  "2022-10-06",
  "2022-10-07",
  "2022-10-08",
  "2022-10-09",
  "2022-10-10",
  "2022-10-11",
  "2022-10-12",
  "2022-10-13",
  "2022-10-14",
  "2022-10-15",
  "2022-10-16",
  "2022-10-17",
  "2022-10-18",
  "2022-10-19",
]
